import "../styles/general.css";

import React, { useRef, useState } from "react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { FaArrowRight } from "react-icons/fa";
import { useCookies } from "react-cookie";
import "swiper/css";
import "swiper/css/pagination";

import { useNavigate } from "react-router-dom";

export default function Slider() {
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const pagination = {
    clickable: true,
    renderBullet: function (index, className = "pg") {
      return '<span className="' + className + '">' + " " + "</span>";
    },
  };
  const [swiper, setSwiper] = useState(null);
  const [isLastSlide, setIsLastSlide] = useState(false);
  return (
    <div className="w-full h-screen  ">
      <Swiper
        pagination={pagination}
        modules={[Pagination, Navigation]}
        initialSlide={4}
        onSwiper={(swiper) => {
          setSwiper(swiper);
        }}
        onSlideChange={(e) => {
          if (e.activeIndex === 0) {
            setIsLastSlide(true);
          } else {
            setIsLastSlide(false);
          }
        }}
        className="w-full h-[100vh]"
        dir="rtl"
      >
        <SwiperSlide className="">
          <img
            src="../assets/images/slider/4.svg"
            alt=""
            className="w-[75.47169811320755vw] h-[75.47169811320755vw]"
          />
          <h1 className="text-[5vw] font-font_primary_A font-semibold mt-[8vw] ">
            مولتی اپلیکیشن
          </h1>
          <div className="flex flex-col justify-center mt-[3.7vw]">
            <p className="font-font_primary_A font-extralight text-[#474747] text-[3.5vw] text-center">
              مجموعه‌ای کامل از خدمات الکترونیکی مورد نیاز مالکان خودرو
            </p>
            <ul className="font-font_primary_A font-extralight text-[#474747] text-[3.5vw] mt-[1vw] text-right pr-[4vw] list-disc">
              <li>تعمیر و نگهداری</li>
              <li>خدمات بیمه‌ای</li>
              <li>استعلام مدارک</li>
              <li>بدهی خودرو</li>
            </ul>
          </div>
        </SwiperSlide>
        <SwiperSlide className=" gap-y-[8vw]">
          <img
            src="../assets/images/slider/3.svg"
            alt=""
            className="w-[75.47169811320755vw] h-[75.47169811320755vw]"
          />
          <h1 className="text-[5vw] font-font_primary_A font-semibold">
            خدمات رایگان
          </h1>
          <p className="font-font_primary_A font-extralight text-[#474747] text-[3.5vw] text-center -mt-[5vw] px-[10vw]">
            ارائه خدمات رایگان به روش ارتباط گیری خدمات گیرنده از خدمات دهنده
          </p>
        </SwiperSlide>
        <SwiperSlide className=" gap-y-[8vw]">
          <img
            src="../assets/images/slider/2.svg"
            alt=""
            className="w-[75.47169811320755vw] h-[75.47169811320755vw] "
          />
          <h1 className="text-[5vw] font-font_primary_A font-semibold">
            خدمات دهنده
          </h1>
          <p className="font-font_primary_A font-extralight text-[#474747] text-[3.5vw] text-center -mt-[5vw] px-[10vw]">
            تعمیرگاه‌های خودرو ارائه دهنده خدمات در سامانه اسکارپین هستند
          </p>
        </SwiperSlide>
        <SwiperSlide className=" gap-y-[8vw]">
          <img
            src="../assets/images/slider/1.svg"
            alt=""
            className="w-[75.47169811320755vw] h-[75.47169811320755vw] "
          />
          <h1 className="text-[5vw] font-font_primary_A font-semibold">
            خدمات گیرنده
          </h1>
          <p className="font-font_primary_A font-extralight text-[#474747] text-[3.5vw] text-center -mt-[5vw] px-[10vw]">
            مالکان خودرو دریافت کننده خدمات در سامانه اسکارپین هستند
          </p>
        </SwiperSlide>
      </Swiper>

      {!isLastSlide && (
        <button
          className="absolute font-font_primary_A top-[5vw] right-[5vw] text-[3.5vw] text-[#474747] z-50"
          onClick={() => {
            const D = new Date().getTime();
            const expire = D + 365 * 24 * 60 * 60 * 1000;
            const expireDate = new Date(expire);
            setCookies("slider", true, {
              path: "/",
              expires: expireDate,
            });
            navigate("/login");
          }}
        >
          رد کردن
        </button>
      )}

      {isLastSlide ? (
        <button
          className="absolute font-font_primary_A text-[4vw] bottom-[3.5vw] right-[5vw] flex items-center justify-between gap-x-[1vw] z-50 bg-color-primary-B px-[8vw] p-[1vw] rounded-[0.9vw] btFadeIn"
          onClick={() => {
            const D = new Date().getTime();
            const expire = D + 365 * 24 * 60 * 60 * 1000;
            const expireDate = new Date(expire);
            setCookies("slider", true, {
              path: "/",
              expires: expireDate,
            });
            navigate("/login");
          }}
        >
          ادامه
        </button>
      ) : (
        <button
          className="absolute font-font_primary_A font-bold text-[4vw] bottom-[5vw] right-[5vw] flex items-center justify-between gap-x-[1vw] z-50"
          onClick={() => {
            swiper.slidePrev();
          }}
        >
          <FaArrowRight size={16} className="pt-[0.5vw]" />
          بعدی
        </button>
      )}
    </div>
  );
}
